import { useEffect, useState } from "react";
import { Building2, CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { btn, btnOutline, errMsg, fmtDate } from "./ui";

export function InstitutionCard({ onChanged }) {
  const [info, setInfo] = useState(null);
  const load = () => api.get("/institution/me").then(({ data }) => setInfo(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!info || (!info.invitations.length && !info.org_name)) return null;
  const answer = async (id, choice) => {
    try {
      await api.post(`/institution/invitations/${id}/${choice}`);
      toast.success(choice === "accept" ? "Institutional license activated" : "Invitation declined");
      load(); onChanged?.();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="bg-white rounded-xl border border-sky-200 p-6 shadow-sm mt-5" data-testid="institution-card">
      <h3 className="font-heading font-semibold text-slate-900 flex items-center gap-2"><Building2 className="w-4 h-4 text-[#1C6FE3]" /> Institutional license</h3>
      {info.org_name && (
        <p className="text-sm text-slate-600 mt-2" data-testid="institution-active">Licensed by <b>{info.org_name}</b> {info.institution_until?.startsWith("2099") ? <b>for life</b> : <>until <b>{fmtDate(info.institution_until)}</b></>}.
          {info.paused_individual && <> Your individual plan is paused{info.paused_individual.days ? ` with ${info.paused_individual.days} paid days saved` : ""} — it resumes automatically if the institutional license ends.</>}</p>
      )}
      {info.invitations.map((i) => (
        <div key={i.id} className="mt-3 rounded-lg bg-sky-50 border border-sky-200 p-4" data-testid={`invitation-${i.id}`}>
          <p className="text-sm text-slate-700"><b>{i.org_name}</b> invited you to use DentiCision under their contract ({i.until?.startsWith("2099") ? "lifetime access" : `until ${fmtDate(i.until)}`}). If you have an individual subscription it is paused and your remaining paid days are kept — no double billing.</p>
          <div className="flex gap-2 mt-3">
            <button type="button" className={`${btn} bg-emerald-600 text-white hover:bg-emerald-700`} onClick={() => answer(i.id, "accept")} data-testid={`invitation-accept-${i.id}`}><CheckCircle2 className="w-4 h-4" /> Accept</button>
            <button type="button" className={btnOutline} onClick={() => answer(i.id, "decline")} data-testid={`invitation-decline-${i.id}`}><XCircle className="w-4 h-4" /> Decline</button>
          </div>
        </div>
      ))}
    </div>
  );
}
